<template>
    <div class="consultationRecordList">
        <div v-if="list.length">
            <StudentListTable
                :list="list"
                :userType="userType"
            ></StudentListTable>
            <Pagination :pageData="pageData" @changePage="changeCurrent"></Pagination>
        </div>
        <div v-else class="noContent">
            <NoContent></NoContent>
        </div>
    </div>
</template>
<script>
import Add from '@/components/consultant/Add.vue'
import AddBtn from '@/components/consultant/AddBtn.vue'
import StudentListTable from '@/components/consultant/consultationRecord/StudentListTable.vue'
import Pagination from '@/components/consultant/Pagination.vue'
import NoContent from '@/components/NoContent.vue'
export default {
    name: "competitionList",
    components: {
        Add,
        AddBtn,
        StudentListTable,
        Pagination,
        NoContent
    },
    data() {
        return {
            userType: 2,
            studentId: sessionStorage.getItem('myStudentStudentId'),
            list: [],
            pageData: {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数数
                total:1//总条数
            }
        }
    },
    computed: {
    },
    created() {
        this.getStudentInterviewListByStudent(this.pageData);
    },
    methods: {
        changeCurrent(value) {
            this.pageData.current = value;
            this.getStudentInterviewListByStudent(this.pageData);
        },
        // 获取成绩列表
        getStudentInterviewListByStudent(pageData){
            this.$ajax.post(this.G_acapi +this.ports.parent.student.consultationRecord.getStudentInterviewListByParent, {
                pageSize: pageData.pageSize,
                pageNumber: pageData.current
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    let page = res.data.data.page;
                    this.list = res.data.data.list;
                    this.pageData={
                        current:page.pageNumber,//当前页
                        pageSize:page.pageSize,//每页多少条
                        totalPage:page.count,//总页数数
                        total:page.count//总条数
                    };
                }
            })
        },
    }

}
</script>

<style scoped lang="less">
.consultationRecordList {
    background-color: #fff;
    padding: 0 20px;
    min-height: 600px;
}
</style>